export default __webpack_public_path__ + "static/media/Vector.4627d1be.svg";